import React from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { ColorMode, useColorMode } from '@lux/core';
import * as S from './plus-elements.styles';
var PlusBadge = function (message) {
    var colorMode = useColorMode().colorMode;
    var isDarkMode = colorMode === ColorMode.DARK;
    return (React.createElement(S.PlusBadgeWrapper, { withDarkBackground: isDarkMode },
        React.createElement(TranslateScope, { path: "plus" }, message)));
};
export var PlusExclusiveBadge = function () { return PlusBadge(React.createElement(Translate, { message: "exclusive.logoText" })); };
export var PlusEarlyAccessBadge = function () { return PlusBadge(React.createElement(Translate, { message: "plusEarlyAccess" })); };
